import { useLocation } from "react-router-dom";
import { Logo } from "components/Logo/Logo";
import React from "react";
import styled from "styled-components";
import { MAIN_MENU } from "utils/Constants";
import { Button } from "components/Button";
import { HashLink } from "react-router-hash-link";

const Sticky = styled.div`
  position: absolute;
  width: 100%;
  z-index: 1300;
  background-color: black;
`;

const Root = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2.4rem;;
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  // gap: 6rem;
  justify-content: space-between;
  flex-grow: 1;
  margin: 0 2rem 0 11rem;
`;

const MenuItem = styled.div`
  color: ${props => props.theme.colors.primary.white};
  font-size: 1.4rem;
  font-weight: ${props => props.theme.fontWeight.bold};
  text-transform: uppercase;
  border-bottom: ${props => (props.selected ? "1px solid" : "0")};
  border-color: ${props => props.theme.colors.primary.green};
  padding: 0.4rem 0;
  cursor: pointer;
`;

export const Header = () => {
  const location = useLocation();

  return (
    <Sticky>
      <div className="container" style={{maxWidth: "150rem"}}>
        <Root>
          <Logo />
          <Menu>
            {MAIN_MENU.map(({ id, title, url }) => {
              return (
                <MenuItem
                  key={id}
                  selected={url === location?.pathname + location?.hash}
                >
                  {
                    url.indexOf("http") >= 0
                      ? <a href={url} target="_blank" rel="noreferrer">{title}</a>
                      : <HashLink to={url}>{title}</HashLink>
                  }

                </MenuItem>
              );
            })}
          </Menu>
          <Button fontSize="2.1rem">913.732.7864</Button>
        </Root>
      </div>
    </Sticky>
  );
};
